import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpExtenstionsModel, QueryResultsModel } from '../../_base/crud';
import { FollowUpModel, FollowUpState } from '..';
import { each } from 'lodash-es';

export const selectFollowUpState = createFeatureSelector<FollowUpState>('followUp');

export const selectFollowUpById = (followUpId: number) =>
  createSelector(selectFollowUpState, (followUpState) => followUpState.entities[followUpId]);

export const selectFollowUpPageLoading = createSelector(selectFollowUpState, (followUpState) => {
  return followUpState.listLoading;
});

export const selectFollowUpActionLoading = createSelector(
  selectFollowUpState,
  (followUpState) => followUpState.actionsloading,
);

export const selectLastCreatedFollowUpId = createSelector(
  selectFollowUpState,
  (followUpState) => followUpState.lastCreatedFollowUpId,
);

export const selectFollowUpPageLastQuery = createSelector(
  selectFollowUpState,
  (followUpState) => followUpState.lastQuery,
);
export const selectFollowUpErrorState = createSelector(
  selectFollowUpState,
  (followUpState) => followUpState.error,
);
export const selectFollowUpInStore = createSelector(selectFollowUpState, (followUpState) => {
  const items: FollowUpModel[] = [];
  each(followUpState.entities, (element) => {
    items.push(element);
  });
  const httpExtension = new HttpExtenstionsModel();
  const result: FollowUpModel[] = httpExtension.sortArray(
    items,
    followUpState.lastQuery.sortField,
    followUpState.lastQuery.sortOrder,
  );
  return new QueryResultsModel(result, followUpState.totalCount);
});

export const selectFollowUpShowInitWaitingMessage = createSelector(
  selectFollowUpState,
  (followUpState) => followUpState.showInitWaitingMessage,
);

export const selectHasFollowUpInStore = createSelector(selectFollowUpState, (queryResult) => {
  if (!queryResult.totalCount) {
    return false;
  }
  return true;
});
